import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8.45 7.021L12 7.014V5L5 5V12H7.014L7.021 8.45L17.571 19L19 17.571L8.45 7.021Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LongUpLeft"
);
